import React from 'react';
import { EUI_THEMES } from '../../../../src/themes'; // @ts-ignore

import { applyTheme } from '../../services';
var defaultState = {
  theme: EUI_THEMES[0].value,
  changeTheme: function changeTheme(themeValue) {
    applyTheme(themeValue);
  }
};
export var ThemeContext = React.createContext(defaultState);
export class ThemeProvider extends React.Component {
  constructor(props) {
    super(props);
    const theme = localStorage.getItem('theme') || defaultState.theme;
    applyTheme(theme);
    this.state = {
      theme
    };
  }

  changeTheme = themeValue => {
    this.setState({
      theme: themeValue
    }, () => {
      localStorage.setItem('theme', themeValue);
      applyTheme(themeValue);
    });
  };

  render() {
    const {
      children
    } = this.props;
    const {
      theme
    } = this.state;
    return <ThemeContext.Provider value={{
      theme,
      changeTheme: this.changeTheme
    }}>
        {children}
      </ThemeContext.Provider>;
  }

}

try {
  // @ts-ignore
  ThemeProvider.displayName = "ThemeProvider"; // @ts-ignore

  ThemeProvider.__docgenInfo = {
    "description": "",
    "displayName": "ThemeProvider",
    "props": {}
  }; // @ts-ignore

  if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["src-docs/src/components/with_theme/theme_context.tsx#ThemeProvider"] = {
      docgenInfo: ThemeProvider.__docgenInfo,
      name: "ThemeProvider",
      path: "src-docs/src/components/with_theme/theme_context.tsx#ThemeProvider"
    };
} catch (__react_docgen_typescript_loader_error) {}